import type { ReactNode } from 'react'

export interface StripeCallbackProps {
  children?: ReactNode
}

export function StripeCallback({ children }: StripeCallbackProps) {
  return <div>{children}</div>
}
